export default "__VITE_ASSET__ae56acdf__"